@if (visible()) {
  @if (showPill()) {
    <div
      class="pr-scribe-recorder pr-scribe-recorder--minimised"
      data-testid="scribe-recorder"
      cdkDrag
      [cdkDragFreeDragPosition]="dragPosition()"
      (cdkDragEnded)="onDragEnded($event)"
    >
      <span
        class="pr-scribe-recorder__dot"
        aria-hidden="true"
        [class.pr-scribe-recorder__dot--live]="
          status() === ScribeStatus.InProgress
        "
        [class.pr-scribe-recorder__dot--connecting]="
          status() === ScribeStatus.RequestingPermission ||
          status() === ScribeStatus.Connecting
        "
        [class.pr-scribe-recorder__dot--writing]="
          status() === ScribeStatus.Writing
        "
      ></span>
      <span
        class="pr-scribe-recorder__pill-time"
        data-testid="scribe-elapsed"
        >{{ elapsedLabel() }}</span
      >
      <span class="pr-scribe-recorder__patient" data-testid="scribe-patient">{{
        patientName()
      }}</span>
      @if (showReturn()) {
        <button
          type="button"
          class="pr-scribe-recorder__icon-button pr-scribe-recorder__icon-button--compact"
          data-testid="scribe-return"
          matTooltip="Back to appointment"
          aria-label="Back to appointment"
          (pointerdown)="$event.stopPropagation()"
          (click)="navigateBack()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <button
        type="button"
        class="pr-scribe-recorder__icon-button pr-scribe-recorder__icon-button--compact"
        data-testid="scribe-expand"
        matTooltip="Expand recorder"
        aria-label="Expand recorder"
        (pointerdown)="$event.stopPropagation()"
        (click)="toggleMinimise()"
      >
        <mat-icon>open_in_full</mat-icon>
      </button>
    </div>
  } @else {
    <div
      #cardContainer
      class="pr-scribe-recorder"
      data-testid="scribe-recorder"
      cdkDrag
      [cdkDragFreeDragPosition]="dragPosition()"
      [class.pr-scribe-recorder--blocked]="
        status() === ScribeStatus.PermissionDenied
      "
      [class.pr-scribe-recorder--failed]="status() === ScribeStatus.Failed"
      (cdkDragEnded)="onDragEnded($event)"
    >
      <div class="pr-scribe-recorder__header" cdkDragHandle>
        <span
          class="pr-scribe-recorder__dot"
          aria-hidden="true"
          [class.pr-scribe-recorder__dot--live]="
            status() === ScribeStatus.InProgress
          "
          [class.pr-scribe-recorder__dot--connecting]="
            status() === ScribeStatus.RequestingPermission ||
            status() === ScribeStatus.Connecting
          "
          [class.pr-scribe-recorder__dot--writing]="
            status() === ScribeStatus.Writing
          "
          [class.pr-scribe-recorder__dot--blocked]="
            status() === ScribeStatus.PermissionDenied ||
            status() === ScribeStatus.Failed
          "
        ></span>
        <span
          class="pr-scribe-recorder__patient"
          data-testid="scribe-patient"
          >{{ patientName() }}</span
        >
        <span
          class="pr-scribe-recorder__status-label"
          role="status"
          data-testid="scribe-status-label"
          [class.pr-scribe-recorder__status-label--connecting]="
            status() === ScribeStatus.RequestingPermission ||
            status() === ScribeStatus.Connecting
          "
          [class.pr-scribe-recorder__status-label--warn]="
            status() === ScribeStatus.PermissionDenied ||
            status() === ScribeStatus.Failed
          "
          >{{ statusLabel() }}</span
        >
        @if (showReturn()) {
          <button
            type="button"
            class="pr-scribe-recorder__icon-button pr-scribe-recorder__icon-button--compact"
            data-testid="scribe-return"
            matTooltip="Back to appointment"
            aria-label="Back to appointment"
            (pointerdown)="$event.stopPropagation()"
            (click)="navigateBack()"
          >
            <mat-icon>arrow_back</mat-icon>
          </button>
        }
        @if (!isErrorState()) {
          <button
            type="button"
            class="pr-scribe-recorder__icon-button pr-scribe-recorder__icon-button--compact"
            data-testid="scribe-minimise"
            matTooltip="Minimise recorder"
            aria-label="Minimise recorder"
            (pointerdown)="$event.stopPropagation()"
            (click)="toggleMinimise()"
          >
            <mat-icon>close_fullscreen</mat-icon>
          </button>
        }
      </div>

      @switch (status()) {
        @case (ScribeStatus.RequestingPermission) {
          <div class="pr-scribe-recorder__permission">
            <span class="pr-scribe-recorder__spinner" aria-hidden="true"></span>
            <div class="pr-scribe-recorder__permission-copy">
              <span class="pr-scribe-recorder__permission-title"
                >Requesting microphone access…</span
              >
              <span class="pr-scribe-recorder__permission-detail"
                >Allow the microphone in your browser to start.</span
              >
            </div>
          </div>
        }

        @case (ScribeStatus.Connecting) {
          <div class="pr-scribe-recorder__permission">
            <span class="pr-scribe-recorder__spinner" aria-hidden="true"></span>
            <div class="pr-scribe-recorder__permission-copy">
              <span class="pr-scribe-recorder__permission-title"
                >Connecting…</span
              >
              <span class="pr-scribe-recorder__permission-detail"
                >Setting up — recording starts in a moment.</span
              >
            </div>
          </div>
        }

        @case (ScribeStatus.PermissionDenied) {
          <div class="pr-scribe-recorder__notice" role="alert">
            <mat-icon class="pr-scribe-recorder__notice-icon"
              >error_outline</mat-icon
            >
            <div class="pr-scribe-recorder__notice-copy">
              <span class="pr-scribe-recorder__notice-title">{{
                microphoneMessage().title
              }}</span>
              <span class="pr-scribe-recorder__notice-detail">{{
                microphoneMessage().detail
              }}</span>
            </div>
          </div>
          <div class="pr-scribe-recorder__actions">
            <button
              type="button"
              class="pr-scribe-recorder__icon-button"
              data-testid="scribe-retry"
              matTooltip="Try again"
              aria-label="Try again"
              (click)="retry()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
            <button
              type="button"
              class="pr-scribe-recorder__icon-button"
              data-testid="scribe-dismiss"
              matTooltip="Discard"
              aria-label="Discard"
              (click)="dismiss()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }

        @case (ScribeStatus.Writing) {
          <div class="pr-scribe-recorder__writing">
            <span data-testid="scribe-writing-title"
              >{{ writingTitle() }} {{ writingElapsedLabel() }}</span
            >
            <span
              class="pr-scribe-recorder__writing-detail"
              data-testid="scribe-writing-detail"
              >{{ writingDetail() }}</span
            >
            @if (canFinishInBackground()) {
              <button
                mat-stroked-button
                type="button"
                class="pr-scribe-recorder__finish-background"
                data-testid="scribe-finish-background"
                (click)="finishInBackground()"
              >
                Finish in background
              </button>
            }
          </div>
          <div class="pr-scribe-recorder__progress" aria-hidden="true">
            <span class="pr-scribe-recorder__progress-bar"></span>
          </div>
          <div
            class="pr-scribe-recorder__actions pr-scribe-recorder__actions--disabled"
          >
            <button
              type="button"
              class="pr-scribe-recorder__icon-button pr-scribe-recorder__icon-button--stop"
              data-testid="scribe-stop"
              matTooltip="Stop recording"
              aria-label="Stop recording"
              [disabled]="true"
            >
              <mat-icon>stop</mat-icon>
            </button>
            <button
              type="button"
              class="pr-scribe-recorder__icon-button"
              data-testid="scribe-discard"
              matTooltip="Discard recording"
              aria-label="Discard recording"
              [disabled]="true"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }

        @case (ScribeStatus.Failed) {
          <div class="pr-scribe-recorder__notice" role="alert">
            <mat-icon class="pr-scribe-recorder__notice-icon"
              >error_outline</mat-icon
            >
            <div class="pr-scribe-recorder__notice-copy">
              <span
                class="pr-scribe-recorder__notice-title"
                data-testid="scribe-failed-title"
                >{{ failureTitle() }}</span
              >
              <span
                class="pr-scribe-recorder__notice-detail"
                data-testid="scribe-failed-detail"
                >{{ failureDetail() }}</span
              >
            </div>
          </div>
          <div class="pr-scribe-recorder__actions">
            <button
              type="button"
              class="pr-scribe-recorder__icon-button"
              data-testid="scribe-dismiss"
              matTooltip="Dismiss"
              aria-label="Dismiss"
              (click)="dismiss()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }

        @default {
          <div class="pr-scribe-recorder__elapsed" data-testid="scribe-elapsed">
            {{ elapsedLabel() }}
          </div>
          <div class="pr-scribe-recorder__bands" aria-hidden="true">
            @for (level of bars(); track $index) {
              <span
                class="pr-scribe-recorder__band"
                [style.height.%]="level"
              ></span>
            }
          </div>
          <div class="pr-scribe-recorder__actions">
            <button
              type="button"
              class="pr-scribe-recorder__icon-button pr-scribe-recorder__icon-button--stop"
              data-testid="scribe-stop"
              matTooltip="Stop recording"
              aria-label="Stop recording"
              (click)="stop()"
            >
              <mat-icon>stop</mat-icon>
            </button>
            <button
              type="button"
              class="pr-scribe-recorder__icon-button"
              data-testid="scribe-discard"
              matTooltip="Discard recording"
              aria-label="Discard recording"
              (click)="discard()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          @if (persistenceError()) {
            <div class="pr-scribe-recorder__persistence" role="alert">
              <mat-icon class="pr-scribe-recorder__persistence-icon"
                >warning</mat-icon
              >
              <span>Some notes could not be saved.</span>
            </div>
          }
        }
      }
    </div>
  }
}
